export const INSIGHTS_PERIODS = {
  THIRTY_DAYS: 'THIRTY_DAYS',
  TOTAL: 'TOTAL',
}

export const INSIGHTS_PERIODS_NAMES = {
  THIRTY_DAYS: 'Last 30 days',
  TOTAL: 'All time',
}
